export class worklogM {
    CLIENT_ID: number;
    ID: number;
    TYPE: number;
    TYPE_ID: number;
    USER_ID: number;
    SPENT_HOURS: any;
    SPENT_MINUTES: any;
    SPENT_SECONDS: any;
    WORK_DESCRIPTION: String;
    WORKED_DATETIME: any;
    IS_ACTIVE: boolean;
    START_DATETIME: any;
    END_DATETIME: any;
    PROJECT_ID: any;
    PROGRESS
}